// extracted by mini-css-extract-plugin
export default {"confirmationPage":"styles_confirmationPage__irvoc"};